/**
 * SPA API Service
 * Endpoints for SPA configuration and auth state
 */
import api from './index';

export const spaApi = {
    /**
     * Get app configuration
     * @returns {Promise} Config data
     */
    getConfig() {
        return api.get('/api/spa/config');
    },

    /**
     * Get current user info
     * @returns {Promise} User data
     */
    getUser() {
        return api.get('/api/spa/user');
    },

    /**
     * Get antiforgery token
     * @returns {Promise} Token data
     */
    getAntiforgeryToken() {
        return api.get('/api/spa/antiforgery');
    },

    /**
     * Get OAuth login context
     * @param {string} returnUrl - Return URL
     * @returns {Promise} Login context
     */
    getLoginContext(returnUrl) {
        return api.get('/api/spa/login-context', { params: { returnUrl } });
    },

    /**
     * Get consent context
     * @param {string} returnUrl - Return URL
     * @returns {Promise} Consent context
     */
    getConsentContext(returnUrl) {
        return api.get('/api/spa/consent-context', { params: { returnUrl } });
    },

    /**
     * Submit consent decision
     * @param {Object} data - Consent decision
     * @returns {Promise} Result
     */
    submitConsent(data) {
        return api.post('/api/spa/consent', data);
    },

    /**
     * Get logout context
     * @param {string} logoutId - Logout ID
     * @returns {Promise} Logout context
     */
    getLogoutContext(logoutId) {
        return api.get('/api/spa/logout-context', { params: { logoutId } });
    },

    /**
     * Execute logout
     * @param {string} logoutId - Logout ID
     * @returns {Promise} Result
     */
    logout(logoutId) {
        return api.post('/api/spa/logout', { logoutId });
    },

    /**
     * Get user grants
     * @returns {Promise} Grants list
     */
    getGrants() {
        return api.get('/api/spa/grants');
    },

    /**
     * Revoke grant
     * @param {string} clientId - Client ID
     * @returns {Promise} Result
     */
    revokeGrant(clientId) {
        return api.delete(`/api/spa/grants/${clientId}`);
    },

    /**
     * Get family sites matched to current user roles
     * @param {string} lang - Locale (ko/en/ja/zh-cn/zh-tw)
     * @returns {Promise} { data: { locale, sites: FamilySite[] } }
     */
    getFamilySites(lang) {
        return api.get('/api/spa/family-sites', { params: lang ? { lang } : {} });
    },

    /**
     * Get home notices (새 소식 + 추천 서비스 머리말)
     * @param {string} lang - Locale (ko/en/ja/zh-cn/zh-tw)
     * @returns {Promise} { data: { locale, notices: HomeNotice[] } }
     */
    getHomeNotices(lang) {
        return api.get('/api/spa/home-notices', { params: lang ? { lang } : {} });
    },
};
